import "./footer.css";

const Footer = () => {
    return(
        <div className="footer">
            <h5>© 2006-2022 DD214 Clothing</h5>
        </div>

    );
};

export default Footer;